export default Object.freeze({
  // TODO PRODUCT/COMMON 에 사용할수 있는 것을 사용
  POP_TITLE: '상품등록정보 심사',
  POP_TITLE_AFTER: '상품등록정보',
  POP_BASIC_IMFORMATION: '기본정보',
  POP_FIELD: '항목',
  POP_BEFORE_DATA: '변경 전 등록정보',
  POP_DATA: '등록정보',
  POP_AFTER_DATA: '변경 후 등록정보',
  POP_NEED_UPDATE_FIELD: '수정필요항목',
  POP_MALL: '쇼핑몰',
  POP_GROUP_TYPE: '상품군',
  POP_GROUP_TYPE_DELIVERY: '배송상품군',
  POP_GROUP_TYPE_SERVICE: '서비스상품군',
  POP_CLASS_TYPE: '상품유형',
  POP_CLASS_TYPE_DEFAULT: '일반상품',
  POP_CLASS_TYPE_OFFLINE: '오프라인상품',
  POP_CLASS_TYPE_RENTAL: '렌탈상품',
  POP_PARTNER: '파트너사',
  POP_SALE_METHOD_TYPE: '판매방식',
  POP_SALE_METHOD_TYPE_PURCHASE: '사입',
  POP_SALE_METHOD_TYPE_CONSIGNMENT: '위탁',
  POP_ADMIN: '담당자',
  POP_CATEGORY: '표준카테고리',
  POP_DISPLAY_CATEGORY: '전시카테고리',
  POP_PLATFORM_DISPLAYINFO: '플랫폼별 노출설정',
  POP_PLATFORM_DISPLAYINFO_MOBILEWEB: '모바일 웹',
  POP_PLATFORM_DISPLAYINFO_MOBILE: '모바일 앱',
  POP_MEMBER_GRADE_DISPLAYINFO: '회원등급 노출 설정',
  POP_MEMBER_GROUP_DISPLAYINFO: '회원그룹 노출 설정',
  POP_PRODUCT_NAME: '상품명',
  POP_PRODUCT_NAME_EN: '영문상품명',
  POP_PROMOTION_TEXT: '홍보문구',
  POP_BRAND: '브랜드',
  POP_MINOR_PURCHASE_YN: '미성년자구매',
  POP_PAYMENT_MEANS: '결제수단제어',
  POP_PAYMENT_MEANS_PAYCO: '페이코',
  POP_PAYMENT_MEANS_PAYCO_POINT: '페이코 포인트',
  POP_PAYMENT_MEANS_CREDIT: '신용카드',
  POP_PAYMENT_MEANS_REALTIME_TRANSFER: '실시간계좌이체',
  POP_PAYMENT_MEANS_DEPOSIT: '가상계좌',
  POP_PAYMENT_MEANS_ESCROW_REALTIME_TRANSFER: '실시간계좌이체-에스크로',
  POP_PAYMENT_MEANS_ESCROW_VIRTUAL_ACCOUNT: '가상계좌-에스크로',
  POP_CART: '장바구니',
  POP_KEYWORDS: '검색어',
  POP_RELATED_PRODUCT_CONFIG: '관련상품 설정',
  POP_NOT_USED: '사용안함',
  POP_SELECTED: '개별상품',
  POP_LATEST_REGISTER_DATE: '최신등록순',
  POP_SALES_COUNT: '판매량순',
  POP_REVIEW_COUNT: '상품평순',
  POP_CUSTOM_ORDER: '수동진열',
  POP_SALE_INFO: '판매정보',
  POP_RESERVATION_INFO: '예약판매',
  POP_SALE_PERIOD_INFO: '판매기간',
  POP_SALE_PERIOD_INFO_REGULAR: '상시 판매',
  POP_SALE_PERIOD_INFO_ELSE: '기간지정 판매',
  POP_COMMISSION_INFO: '판매수수료',
  POP_COMMISSION_INFO_PRODUCT: '상품수수료',
  POP_COMMISSION_INFO_CATEGORY: '카테고리수수료',
  POP_COMMISSION_INFO_PARTNER: '파트너수수료',
  POP_COMMISSION_INFO_PURCHASE_PRICE: '공급가입력',
  POP_SALE_PRICE: '판매가',
  POP_IMMEDIATE_DISCOUNT_INFO: '즉시할인',
  POP_PURCHASE_PRICE: '매입가',
  POP_SUPPLY_PRICE: '공급가',
  POP_PARTNER_CHARGE_AMT: '파트너사분담금',
  POP_ACCUMULATION_RATE: '개별 적립금 설정',
  POP_ACCUMULATION_USEYN: '적립금사용',
  POP_PROMOTION_INFO: '프로모션',
  POP_PRODUCT_STOCK_CNT: '재고수량(판매가능재고)',
  POP_PRODUCT_RESTOCK_HOUSE: '재입고 알림 사용설정',
  POP_MIN_BUY_CNT: '최소구매수량',
  POP_MIN_BUY_CNT_OPTION: '이상 구매가능',
  POP_MAX_BUY_COUNT_INFO: '최대구매수량',
  POP_MAX_BUY_COUNT_INFO_PERSON: '1인 구매시 최대 ',
  POP_MAX_BUY_COUNT_INFO_PERSON2: '개 까지 구매가능',
  POP_MAX_BUY_COUNT_INFO_TIME: '1회 구매시 최대 ',
  POP_MAX_BUY_COUNT_INFO_TIME2: '개 까지 구매가능',
  POP_MAX_BUY_COUNT_INFO_DAY: '최대구매수량 기간 제한 - 제한 수량',
  POP_MAX_BUY_COUNT_INFO_CNT: '일 동안 최대 ',
  POP_MAX_BUY_COUNT_INFO_CNT2: '개 까지 구매가능',
  POP_OPTIONS: '옵션',
  POP_MALL_ADDITION_PRODUCT: '추가상품',
  POP_COMPARING_PRICE_SITE_INFO: '가격비교사이트 등록',
  POP_COMPARING_PRICE_SITE_INFO_NAVER: '네이버쇼핑',
  POP_COMPARING_PRICE_SITE_INFO_DAUM: '다음쇼핑하우',
  POP_COMPARING_PRICE_SITE_INFO_ENURI: '에누리',
  POP_COMPARING_PRICE_SITE_INFO_DANAWA: '다나와',
  POP_COMPARING_PRICE_SITE_INFO_COOCHA: '쿠차',
  POP_COMPARING_PRICE_SITE_INFO_PAYCO: '페이코쇼핑',
  POP_PLACE_ORIGIN_INFO: '원산지',
  POP_DUTY_CONTENT: '상품정보고시',
  POP_DUTY_CONTENT2: '상품고시',
  POP_CERTIFICATION_INFO: '인증정보',
  POP_CERTIFICATION_INFO_TARGET: '인증대상',
  POP_CERTIFICATION_INFO_NOT_TARGET: '인증대상아님',
  POP_CERTIFICATION_INFO_DETAIL_PAGE: '상세페이지 별도표기',
  POP_MANUFACTURE_YMDT: '제조일자',
  POP_EXPIRATION_YMDT: '유효일자',
  POP_VALUE_ADDED_TAX_TYPE: '부가세',
  POP_VALUE_ADDED_TAX_TYPE_DUTY: '과세',
  POP_VALUE_ADDED_TAX_TYPE_DUTYFREE: '면세',
  POP_VALUE_ADDED_TAX_TYPE_SMALL: '영세',
  POP_PRODUCT_MANAGEMENT_CD: '상품관리코드',
  POP_REFUNDABLE_YN: '주문환불',
  POP_STICKERS: '스티커',
  POP_IMAGE_INFO: '이미지정보',
  POP_MAIN_IMAGE: '대표이미지',
  POP_LIST_IMAGE: '리스트 이미지',
  POP_CONTENT_HEADER: '상품 상세(상단)',
  POP_CONTENT_FOOTER: '상품 상세(하단)',
  POP_CONTENT: '상품 상세',
  POP_UPDATE: '수정필요',
  POP_UPDATE2: '수정요청',
  POP_DELIVERY_INFO: '배송정보',
  POP_SHIPPING_AREA_TYPE: '배송구분',
  POP_SHIPPING_AREA_TYPE_PARTNER: '파트너 배송',
  POP_SHIPPING_AREA_TYPE_MALL: '쇼핑몰 배송',
  POP_DELIVERY_COMBINATION_YN: '묶음배송 가능여부',
  POP_DELIVERY_INTERNATIONAL_YN: '해외배송 여부',
  POP_DELIVERY_TYPE: '배송방법/택배사',
  POP_DELIVERY_CONDITION_TYPE: '배송비유형',
  POP_RELEASE_WAREHOUSE: '출고지주소',
  POP_RETURN_WAREHOUSE: '반품교환지 주소',
  POP_RETURN_DELIVERY_AMT: '반품/교환 배송비',
  POP_DELIVERY_CUSTOMER_INFO: '판매자 특이사항/고객안내사항',
  POP_ETC_INFO: '별도 승인거부 의견',
  POP_ADD: '지급',
  POP_COUPON: '쿠폰',
  POP_ADDITIONALDISCOUNT: '추가할인',
  POP_REFUND_Y: '환불가능',
  POP_REFUND_N: '환불불가',
  POP_NO: '등록안함',
  POP_ALL: '등록(전체)',
  POP_REGISTER: '등록',
  POP_USE_REGISTERED_OPTIONAL_IMAGES: '등록된 옵션이미지 사용',
  POP_CAN_DELIVERY_COMBINATION: '묶음배송 가능',
  POP_UNABLE_DELIVERY_COMBINATION: '묶음배송 불가능',
  POP_DELIVERY_INTERNATIONAL_Y: '해외배송상품 (해외 -> 대한민국으로 배송되는 상품)',
  POP_DELIVERY_INTERNATIONAL_N: '국내배송상품',
  SALE_APPROVE: '판매승인',
  APPROVE_REJECT: '승인거부',
  POP_DISPLAY: '노출',
  POP_NOT_SET: '설정안함',
  POP_ALL_SET: '전체 설정',
  POP_ALL_GROUP: '전체 회원그룹',
  POP_ALL_GRADE: '전체 회원등급',
  POP_DUE: '설정기간',
  POP_ALL_CAN: '전체가능',
  POP_DUE_SET: '기간설정',
  POP_FIXED_FEE: '배송비',
  POP_ORDER_AMT: '주문금액',
  POP_CONDITION: '원 이상 배송비 무료 미만 시',
  POP_APPROVE_SUCCESS: '승인이 완료되었습니다.',
  POP_REJECT_SUCCESS: '승인을 거절하였습니다.',
  POP_APPROVE_FAIL: '승인을 실패하였습니다.',
  POP_REJECT_FAIL: '승인거절을 실패하였습니다.',
  NON_MEMBER_PURCHASE_N: '비회원 구매 불가',
  NAVER_PAY_LIMIT_Y: '네이버페이 결제 불가',
  POP_FREE: '배송비 무료',
  POP_TEXTAREA_PLACEHOLDER: '위 항목에 대한 요청사항을 입력할 수 있습니다.(최대 500자)',
  POP_SEARCHENGINE_DISPLAY_Y: '검색엔진 미노출',
  POP_SEARCHENGINE_DISPLAY_N: '검색엔진 노출',
  POP_DISCOUNT_PRICE: '할인적용가',
  POP_RESERVATION_PERIOD: '예약판매기간',
  RESERVATION_DELIVERY_STARTYMD: '배송시작일',

  ITEM: '총',
  AMONG_THE_PRODUCTS: '개 상품 중',
  PRODUCT_INFORMATION_OF_EACH_PRODUCT_HAS_BEEN_CHANGED: '개 상품의 상품정보가 변경되었습니다.',
  HAS_BEEN_CHANGED: '변경 되었습니다.',
  CANNOT_BE_JUDGED: '심사불가',
  // ITEM: '총',
  // AMONG_THE_PRODUCTS: '개 상품 중',
  PRODUCT_INFORMATION_OF_EACH_PRODUCT_CANNOT_BE_CHANGED: '개 상품의 상품정보 변경이 불가합니다.',
  TITLE_CONFIRM: '판매승인',
  TITLE_REJECT: '승인거부',
  HEADER1: '상품번호',
  HEADER2: '내용',

  SHOPPING_MALL: '쇼핑몰',
  PRODUCT_GROUP: '상품군',
  PRODUCT_TYPE: '상품유형',
  PARTNER: '파트너사',
  SALES_METHOD: '판매방식',
  MANAGER: '담당자',
  STANDARD_CATEGORY: '표준카테고리',
  EXHIBITION_CATEGORY: '전시카테고리',
  EXPOSURE_SETTING_BY_PLATFORM: '플랫폼별 노출설정',
  MEMBERSHIP_LEVEL_EXPOSURE_SETTING: '회원등급 노출 설정',
  MEMBER_GROUP_EXPOSURE_SETTING: '회원그룹 노출 설정',
  PRODUCT_NAME: '상품명',
  PRODUCT_NAME_IN_ENGLISH: '영문상품명',
  PR_TEXT: '홍보문구',
  BRAND: '브랜드',
  // BRAND: '브랜드',
  PURCHASE_FOR_MINORS: '미성년자구매',
  PAYMENT_METHOD_CONTROL: '결제수단제어',
  NONMEMBER_PURCHASE_IS_NOT_POSSIBLE: '비회원구매불가',
  SHOPPING_BASKET: '장바구니',
  SEARCH_WORD: '검색어',
  PREORDER: '예약판매',
  SALES_PERIOD: '판매기간',
  SALES_COMMISSION: '판매수수료',
  PRICE: '판매가',
  IMMEDIATE_DISCOUNT: '즉시할인',
  PARTNER_CONTRIBUTIONS: '파트너사분담금',
  SAVING_POINTS: '개별 적립금 설정',
  USE_OF_RESERVES: '적립금사용',
  PROMOTION: '프로모션',
  STOCK_QUANTITY_SOLDABLE_STOCK: '재고수량(판매가능재고)',
  USE_RESTOCK_NOTI: '재입고 알림 사용설정',
  MINIMUM_PURCHASE_QUANTITY: '최소구매수량',
  MAXIMUM_PURCHASE_QUANTITY: '최대구매수량',
  OPTION: '옵션',
  REGISTER_PRICE_COMPARISON_SITE: '가격비교사이트 등록',
  PRODUCT_INFORMATION_NOTICE: '상품정보고시',
  ORIGIN: '원산지',
  CERTIFICATION_INFORMATION: '인증정보',
  DATE_OF_MANUFACTURE: '제조일자',
  EFFECTIVE_DATE: '유효일자',
  VAT: '부가세',
  PRODUCT_MANAGEMENT_CODE: '상품관리코드',
  ORDER_REFUND: '주문환불',
  REFUND_INFO: '환불 정보',
  HS_CODE: 'HS CODE',
  STICKER: '스티커',
  ICON_ALL_EXPOSE: '아이콘 - 상시노출',
  ICON_EXPOSE_TIME: '아이콘 - 노출기간',
  ICON_TIME_EXPOSE: '아이콘 - 기간노출',
  NEED_TO_BE_MODIFIED: '수정필요',
  SHIPPING_CLASSIFICATION: '배송구분',
  DELIVERY_SPECIFIED_DATE: '배송지정일',
  BUNDLE_DELIVERY_AVAILABILITY: '묶음배송 가능여부',
  OVERSEAS_DELIVERY: '해외배송 여부',
  SHIPPING_FEE_TEMPLATE: '배송비탬플렛',
  DELIVERY_METHODCOURIER: '배송방법/택배사',
  SHIPPING_COST_TYPE: '배송비유형',
  SHIPPING_ADDRESS: '출고지주소',
  RETURN_EXCHANGE_ADDRESS: '반품교환지 주소',
  RETURNEXCHANGE_SHIPPING_FEE: '반품/교환 배송비',
  SELLERS_SPECIFICSCUSTOMER_INFORMATION: '판매자 특이사항/고객안내사항',
  AMENDMENT_REQUEST: '수정요청',

  ADDITIONALDISCOUNTYN: '추가할인',
  COUPONYN: '쿠폰',
  FREEGIFTYN: '사은품',
});
